export default __webpack_public_path__ + "static/media/csi_ad_active.f715dd1f.svg";